import styled from 'styled-components';
import FiduciaLogo from '../../../assets/images/fiducia-logo.jpg';

const header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 0.125rem solid #606060;
  margin: 0 0 2.5rem 0;
  height: 6.25rem;
  width: 100%;
`;

const logo = styled.div`
  background-image: url(${FiduciaLogo});
  background-repeat: no-repeat;
  background-size: contain;
  width: 21.875rem;
  height: 100%;
`;

const title = styled.div<IFrameDefault>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-weight: bolder;
  width: auto;
  height: 100%;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '2.25rem')};
  color: ${(props) => props.theme.colors.mainColor};
  font-style: ${(props) => (props.fontStyle ? props.fontStyle : 'normal')};
`;

const text = styled.div<IFrameDefault>`
  display: flex;
  justify-content: start;
  align-items: center;
  font-weight: bolder;
  font-size: ${(props) => (props.fontSize ? props.fontSize : '1.45rem')};
  font-style: ${(props) => (props.fontStyle ? props.fontStyle : 'normal')};
  color: ${(props) =>
    props.color ? props.color : props.theme.colors.mainColor};
`;

const table = styled.table`
  width: 100%;
`;

const row = styled.tr`
  font-size: 0.75rem;
  padding: 0.25rem;
  border-bottom: 1px solid #606060;
`;

const column = styled.th`
  padding: 0.25rem;
`;

const data = styled.td`
  padding: 0.25rem;
`;

const page = styled.div`
  @media all {
    .page-break {
      display: none;
    }
  }

  @media print {
    html,
    body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }

  @media print {
    .page-break {
      margin-top: 1rem;
      display: block;
      page-break-before: auto;
    }
  }

  @page {
    size: auto;
    margin: 10mm;
  }
`;

const Pdf = {
  Page: page,
  Header: header,
  Logo: logo,
  Table: table,
  Row: row,
  Column: column,
  Data: data,
  Title: title,
  Text: text,
};

interface IFrameDefault {
  isActive?: boolean | string;
  display?: string;
  gridTemplateAreas?: string;
  gridTemplateColumns?: string;
  gridTemplateRows?: string;
  gridAutoFlow?: string;
  rowGap?: string;
  columnGap?: string;
  gridArea?: string;
  flexDirection?: string;
  alignItems?: string;
  width?: string;
  height?: string;
  backgroundColor?: string;
  color?: string;
  justifyContent?: string;
  margin?: string;
  padding?: string;
  fontStyle?: string;
  fontSize?: string;
}

export default Pdf;
